import { useAuth } from "../contexts/AuthContext";
import { useFx, formatCurrency } from "../contexts/FxContext";
import { DEFAULT_CURRENCY } from "../lib/defaultCurrency";

/**
 * Renders an amount in the pool's native currency, and (when different from the
 * user's display preference) a muted secondary conversion line.
 */
export function CurrencyAmount({ amount, currency = DEFAULT_CURRENCY, decimals = 0, className = "", inline = false, hideConvert = false }) {
    const { user } = useAuth();
    const { convert } = useFx();
    const display = user?.display_currency || DEFAULT_CURRENCY;
    const showConvert = !hideConvert && display && display !== currency;
    const converted = showConvert ? convert(amount || 0, currency, display) : null;

    if (inline) {
        return (
            <span className={className}>
                {formatCurrency(amount || 0, currency, { decimals })}
                {showConvert && (
                    <span className="ml-1 text-[11px] text-white/35 font-normal">
                        ≈ {formatCurrency(converted, display, { decimals: 0 })}
                    </span>
                )}
            </span>
        );
    }

    return (
        <span className={`inline-block tabular-nums ${className}`}>
            <span className="block">{formatCurrency(amount || 0, currency, { decimals })}</span>
            <span className={`block text-[11px] text-white/35 font-normal mt-0.5 min-h-[1rem] ${showConvert ? "" : "invisible"}`}>
                {showConvert ? `≈ ${formatCurrency(converted, display, { decimals: 0 })}` : "—"}
            </span>
        </span>
    );
}
